exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contractEditorGrid[data-v-10fb879e] {\n  display: grid;\n  grid-template-columns: 1fr 3fr;\n}\n.contractEditorGrid .contractControl[data-v-10fb879e] {\n  grid-row: span 2;\n}\n.contractEditorGrid .addMethodButton[data-v-10fb879e] {\n  margin-bottom: 1rem;\n}\n.addMethodButton[data-v-10fb879e] {\n  justify-self: right;\n  grid-column: 2;\n}", ""]);

// exports
